var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('os-reports-overview',{on:{"rowclicked":(e) => this.$router.push('/settings/reports/' + e.id)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }